import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { OnboardingRequest } from "src/app/shared/model/onboarding-request.model";
import { Local } from 'src/app/shared/services/local';
import { MainLayoutService } from 'src/app/shared/services/main-layout.service';
import { ProcessService } from "../../process/process.service";
import { BASK_BRAND_ID } from "../../shared/constants";
import { FacadeService } from "../../shared/service-facade/facade.service";
import { CoreService, PageProps } from "../../shared/services/core.service";
import { Sections, SectionStates } from "../../status-tracker/model/section-status";
import { SectionStatusService } from "../../status-tracker/section-status.service";
import { ReviewState } from "../models/review-state";

//const mParticle = require("@mparticle/web-sdk");
@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit, OnDestroy {
  title: string = "Review Application";
  reviewState: ReviewState = ReviewState.ReadOnly;
  shoppingCartOnboardingRequest: OnboardingRequest;
  shouldHideBsaQuestions: boolean = false;
  isInJointMaintenanceFlow = false;
  applicationHasCoApplicant = false;
  notEnrolledInOLB: BehaviorSubject<boolean | undefined> = new BehaviorSubject<boolean | undefined>(undefined);
  isApplicantFormValid = false;


  private _destroySubject$ = new Subject();

  constructor(private facadeService: FacadeService,
              private coreService: CoreService,
              private mainLayout: MainLayoutService,
              private statusTrackerService: SectionStatusService,
              private processService: ProcessService) {
    this.shoppingCartOnboardingRequest = new OnboardingRequest();

    this.facadeService.updatedAccountSelection$.pipe(
      takeUntil(this._destroySubject$)
    ).subscribe(() => {
      this.setupComponents();
    });
  }

  ngOnInit(): void {
    this.statusTrackerService.updateStatusTrackerSectionStatus(Sections.SelectAccounts, SectionStates.complete);
    this.statusTrackerService.updateStatusTrackerSectionStatus(Sections.YourApplication, SectionStates.complete);

    if (this.facadeService.isInJointMaintenanceFlow()) {
      this.isInJointMaintenanceFlow = true;
    }

    this.notEnrolledInOLB = this.facadeService.notEnrolledInOLB;
    this.notEnrolledInOLB.pipe(
      takeUntil(this._destroySubject$),
      filter(value => typeof value !== 'undefined'),
      filter(notEnrolled => !notEnrolled)
    ).subscribe(notEnrolled => {
      this.statusTrackerService.removeStatusTrackerSection(Sections.CreateLogin);
      Local.log("Removed status tracker section: CreateLogin - notEnrolledInOLB", notEnrolled);
    });

    this.shoppingCartOnboardingRequest = this.facadeService.getShoppingCartOnboardingRequest();

    let props = new PageProps();
    props.title = this.title;
    props.isHomePage = false;
    this.coreService.setPageProps(props);

    const brandId = Number(this.facadeService.getStorageItem("brandId"));

    //comment mParticle, CDP scripts are live, remove the code later
    // mParticle.default.logPageView(
    //   brandId == BASK_BRAND_ID ? "Step 3 - Form Complete" : "Step 3 - Review",
    //   {page: window.location.toString()}
    // );

    window.scrollTo(0, 0);

    this.setupComponents();

    this.mainLayout.setPageTitle(`Review Your Application`);

    this.processService.setDocumentCaptureService();
  }

  ngOnDestroy(): void {
      this._destroySubject$.next();
  }

  setupComponents() {
    this.shouldHideBsaQuestions = this.facadeService.shouldHideBsaQuestions();
  }

  hasCoApplicant(value: boolean): void {
    this.applicationHasCoApplicant = value;
  }

  checkApplicantFormValidity(value: boolean) {
    this.isApplicantFormValid = value;
  }
}
